<template>
	<div
		class="cm-modal modal modal-share-car fade"
		id="modalShareCar"
		tabindex="-1"
		aria-labelledby="modalShareCar"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<p class="lead modal-title" id="modalShareCarLabel">
						Fahrzeug teilen
					</p>
					<button
						type="button"
						class="btn-close"
						data-bs-dismiss="modal"
						aria-label="Close"
					></button>
				</div>
				<div class="modal-body">
					<div class="modal-text border-bottom">
						<div class="mb-3">
							<label for="shareLinkInput" class="form-label"
								>Link zum Fahrzeug</label
							>
							<input
								type="text"
								class="form-control"
								id="shareLinkInput"
								:value="shareCarUrl"
								readonly
							/>
						</div>
					</div>
					<div class="modal-text">
						<a
							href="#"
							@click.prevent="this.copyToClipboard('shareLinkInput')"
							class="btn btn-block btn-dark mb-2"
						>
							<i class="mdi mdi-content-copy"></i>
							Link kopieren
						</a>
						<a
							:href="shareCarUrlWhatsapp"
							class="mb-2 btn btn-share-search-whatsapp btn-dark btn-block"
						>
							<i class="mdi mdi-whatsapp"></i>
							Per WhatsApp teilen
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DarmasApiService from '@/services/DarmasApiService'
import store from '@/store'

export default {
	name: 'DetailsModalShareCar',
	props: {
		car: Object,
	},
	computed: {
		shareCarUrl() {
			return DarmasApiService.urlToCarDetails(this.car._id)
		},
		isBookmarked() {
			return store.state.user.bookmarks.cars[this.car._id] === undefined
		},
		shareCarUrlWhatsapp() {
			return (
				'whatsapp://send?text=Dieses Fahrzeugangebot habe ich auf darmas.de gefunden ' +
				DarmasApiService.urlToCarDetails(this.car._id)
			)
		},
	},
}
</script>

<style scoped></style>
